module.exports = __webpack_public_path__ + "media/images/pic/courses/02-0b17bdf28af439c4cc8bff8ae332a33d.svg";